import React from "react";
import {Props_SnippetImageBlock} from './ImageBlock.props'

export const SnippetImageBlock = (props: Props_SnippetImageBlock) => {
    const titleClass = props.heading.visibility.value === "hidden" ? 'snippet-image-block__title accessible-heading' : 'snippet-image-block__title';

    return (
        <section className="snippet-image-block">
            <div className="snippet-image-block__container">
                <h2 className={titleClass}>{props.heading?.heading?.value}</h2>

                <div className="snippet-image-block__image-section">
                {props.repeatable_image?.map((image, index) => (
                    <figure key={index} className="snippet-image-block__image-container">
                        <img
                            className="snippet-image-block__image"
                            src={image.src?.value}
                            alt={image.alt?.value}
                            width="200"
                            height="200"
                            loading="lazy"
                        />
                    </figure>
                ))}
            </div></div>
        </section>
    );
}